import { snakeToTitleCase } from 'lib/helpers/utility';

import Status from 'components/shared/Status/Status';

const formatValue = (value, format) => {
  if (value === null || value === undefined || value === '') return '—';
  if (format === 'title') return snakeToTitleCase(String(value));
  return String(value);
};

const Field = ({ label, value, format }) => {
  if (format === 'bool') {
    return (
      <div className="flex items-center justify-between gap-2 py-1">
        <span className="text-xs text-neutral-600">{label}</span>
        <Status
          status={value ? 'Supported' : 'Unavailable'}
          color={value ? 'success' : 'neutral'}
          size="small"
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-0.5 py-1">
      <span className="text-xs text-neutral-600">{label}</span>
      <span className="break-all text-sm font-500 text-neutral-900">
        {formatValue(value, format)}
      </span>
    </div>
  );
};

export default Field;
